/**
 * Created by rickborst on 22/02/2017.
 */

import {ActionTypes} from 'store/actions/paymentdetails';

import PaymentDetails from 'models/paymentdetails';

const defaultPaymentDetailsState = Object.assign({}, new PaymentDetails());

/**
 * Payment details reducer.
 *
 * @param {Object} state - State of the component.
 * @param {Object} action - Action payload.
 * @returns {Object} User reducer.
 */
function paymentDetails (state = defaultPaymentDetailsState, action) {
    switch (action.type) {

        case ActionTypes.UPDATE_PAYMENT_DETAILS:
            state = {
                ...state,
                ...action.paymentDetails,
                tmp: state.tmp
            };
            return state;

        case ActionTypes.CLEAR_PAYMENT_DETAILS:
            state = {
                ...state,
                ...defaultPaymentDetailsState,
                tmp: state.tmp
            };
            return state;

        case ActionTypes.SET_PAYMENT_TMP:
            state = {
                ...state,
                tmp: action.paymentTmp
            };
            return state;

        default:
            return state;
    }
}

export default paymentDetails;


// WEBPACK FOOTER //
// ./src/js/store/reducers/paymentdetails.js